import { ClientUserTeamConnectionsResource } from 'dy-frontend-http-repository/lib/modules/ClientUser/resources';
import { TeamResource } from 'dy-frontend-http-repository/lib/modules/Team/resources';
import { createApi } from 'effector';
import { connect } from 'effector-react';
import moment from 'moment';

import { $teamConnections } from './states';

export const teamConnectionsApi = createApi($teamConnections, {
    // Create team connection
    create: (store, payload: { connectionId: ID; userId: ID; team: TeamResource }) => {
        if (!store) {
            // Team connections were not fetched yet
            return store;
        }

        const momentNowUtc = moment().utc().format();
        const { connectionId, userId, team } = payload;
        const newClientTeamConnection: ClientUserTeamConnectionsResource = {
            id: connectionId,
            attached_at: momentNowUtc,
            client_user_id: userId,
            detached_at: null,
            team: { id: team.id, color: team.color, summary: team.summary, title: team.title },
        };

        return { ...store, items: [newClientTeamConnection, ...store.items] };
    },

    // Remove team connection
    remove: (store, payload: { connectionId: ID }) => {
        if (!store) {
            // Team connections were not fetched yet
            return store;
        }

        // Filter out connection which should be removed
        const filteredTeamConnections = store.items
            .slice(0)
            .filter((connection) => connection.id !== payload.connectionId);

        return { ...store, items: filteredTeamConnections };
    },
});
